import { Box, Typography } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import { WPRListDto } from "~/api/GeneratedApi";
import GenericTable, {
  CustomColumn,
  CustomTableProps,
} from "~/components/GenericTable";
import { useGetWPRTemplateList } from "./hooks/useGetWPRTemplateList";
import { useWPRContext } from "./hooks/useWPRContext";

// function timeout(ms: number) {
//   return new Promise((resolve) => {
//     setTimeout(resolve, ms);
//   });
// }

export const WPRStartStep = () => {
  const { setSelectedExcelBase, selectedExcelBase } = useWPRContext();

  const { wprTemplates } = useGetWPRTemplateList();
  const { t } = useTranslation("");

  const columns = React.useMemo((): CustomColumn<WPRListDto>[] => {
    return [
      {
        field: "fullName",
        title: t("profile:node-name"),
        width: "min-content",
        render: ({ fullName }) => (
          <Box sx={{ display: "flex", gap: "10px" }}>
            <Typography>{fullName}</Typography>
          </Box>
        ),
      },
      //   {
      //     field: "bytes",
      //     title: t("file-explorer:table-file-size"),
      //   },
    ];
  }, [t]);

  const tableProps = React.useMemo(
    (): CustomTableProps<WPRListDto> => ({
      title: t("WPR:excelBases"),
      options: {
        filtering: false,
        pageSize: 10,
        idSynonym: "id",

        rowStyle: (rowData) => {
          const row = rowData as WPRListDto;

          const style =
            row?.id === selectedExcelBase?.id
              ? { backgroundColor: "#4fc3f74d" }
              : {};
          return style;
        },
      },
      onRowClick: (_e, fileTemp) => setSelectedExcelBase(fileTemp),

      actions: [
        // {
        //   icon: "delete",
        //   tooltip: t("general:delete"),
        // },
        // {
        //   icon: "add",
        //   tooltip: t("general:add"),
        //   onClick: () => setShowStepper(true),
        //   isFreeAction: true,
        // },
      ],
    }),
    [selectedExcelBase, setSelectedExcelBase, t],
  );

  return (
    // <Box
    //   sx={{
    //     display: "grid",
    //     alignItems: "center",
    //     justifyContent: "center",
    //     gap: "15px",
    //     pb: "20px",
    //     gridTemplateColumns: "repeat(auto-fill, 300px)",
    //   }}
    // >
    <Box
      sx={{
        "& div": {
          boxShadow: "none",
        },
      }}
    >
      <GenericTable
        columns={columns}
        tableProps={tableProps}
        data={wprTemplates ?? []}
      />
    </Box>
  );
};
